import { supabase } from '@/lib/supabase';

/**
 * Elimina permanentemente el historial de recibos y los movimientos de ingreso
 * generados a partir de ellos, evitando registros huérfanos.
 * Protegido en la base de datos mediante RLS (solo superUsuario).
 */
export async function purgeReceiptHistory(): Promise<void> {
  // 1. Movimientos financieros vinculados a recibos.
  const { error: movementError } = await supabase
    .from('financial_movements')
    .delete()
    .not('receipt_id', 'is', null);
  if (movementError) throw movementError;

  // 2. Recibos.
  const { error: receiptError } = await supabase
    .from('receipts')
    .delete()
    .not('id', 'is', null);
  if (receiptError) throw receiptError;
}

/**
 * Elimina únicamente el historial de cambios (auditoría de eventos) de los proyectos.
 * No elimina proyectos, clientes, recibos, movimientos, contratos ni usuarios.
 * Protegido en la base de datos mediante RLS (solo superUsuario).
 */
export async function purgeProjectEventHistory(): Promise<void> {
  const { error } = await supabase.from('project_events').delete().not('id', 'is', null);
  if (error) throw error;
}